import React, {
  forwardRef,
  useImperativeHandle,
  useState,
} from "react";
import "./cmodal.css";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import successImg from "../../../assets/Admin/success-illus.svg";
import warningImg from "../../../assets/Admin/warning-illus.svg";
import failureImg from "../../../assets/Admin/failure-illus.svg";
import close from "../../../assets/Admin/close.svg";
import StateSelectors from "../../../utils/Admin/constants/selector.constants";
import { resetAllReduxState } from "../../../store/Admin/authentication/authentication.actions";
import { hideLoader } from "../../../store/Admin/Loader/loader.slice";

const CModal = ({ callbackFunc, onClickCancel, onClickProceed }, ref) => {
  const { tokenExpired } = useSelector(StateSelectors.USER_SELECTOR);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [show, setShow] = useState(false);
  const [success, setSuccess] = useState(false);
  const [warning, setWarning] = useState(false);
  const [failure, setFailure] = useState(false);
  const [showActionBtn, setShowActionBtn] = useState(false);
  const [textMessage, setTextMessage] = useState("");
  const [footerConfig, setFooterConfig] = useState({
    noOfBtns: 0,
    showCancel: false,
    showProceed: false,
    cancelBtnLabel: "cancel",
    proceedBtnLabel: "proceed",
  });

  const handleLoginRedirection = () => {
    sessionStorage.clear();
    dispatch(resetAllReduxState());
    dispatch(hideLoader())
    navigate("login");
  };

  const resetToDefault = () => {
    setSuccess(false);
    setFailure(false);
    setTextMessage("");
    setShowActionBtn(false);
    setFooterConfig({
      noOfBtns: 0,
      showCancel: false,
      showProceed: false,
      cancelBtnLabel: "cancel",
      proceedBtnLabel: "proceed",
    });
  };

  useImperativeHandle(ref, () => ({
    modalVisibility: (bool) => {
      if (bool === false) {
        resetToDefault();
      }
      setShow(bool);
    },

    showModalContent: (type, message, btnVisibility) => {
      if (type === "success") {
        setTextMessage(message);
        setFailure(false);
        setWarning(false);
        setSuccess(true);
      } else if (type === "warning") {
        setTextMessage(message);
        setSuccess(false);
        setFailure(false);
        setWarning(true);
      } else if (type === "failure") {
        setTextMessage(message);
        setSuccess(false);
        setWarning(false);
        setFailure(true);
      }
      setShowActionBtn(btnVisibility);
      setShow(true);
    },
    setFooterDetails: (conf) => {
      setFooterConfig(conf);
    },
  }));

  const onModalClose = () => {
    setShow(false);
    resetToDefault();
    if (tokenExpired === true) {
      handleLoginRedirection();
      return
    } else if (typeof callbackFunc === "function" && tokenExpired === false) {
      callbackFunc();
    }
  };

  const handleProceed = () => {
    resetToDefault();
    onClickProceed();
  };

  return (
    <Modal
      show={show}
      className="custom-admin-modal"
      onHide={() => setShow(false)}
      backdrop="static"
      keyboard={false}
      centered
      onBackdropClick={onModalClose}
    >
      <Modal.Header className="pt-3 pb-2 justify-content-end borderNone">
        <img
          onClick={onModalClose}
          className="admin-modal-closeImg cursor-pointer"
          width="15"
          height="15"
          src={close}
          alt="close"
        />
      </Modal.Header>
      <Modal.Body className="text-center mx-auto">
        <div className="text-center upload-success-modal">
          <img hidden={!success} src={successImg} alt="upload success" />
          <img hidden={!warning} src={warningImg} alt="upload warning" />
          <img hidden={!failure} src={failureImg} alt="upload failure" />
          <h6
            className={
              success === true
                ? "text-capitalize doc-success-text mb-0 py-4 mt-4"
                : warning
                ? "text-capitalize doc-warning-text mb-0 py-4 mt-4"
                : "text-capitalize doc-failure-text mb-0 py-4 mt-4"
            }
          >
            {textMessage}
          </h6>
        </div>
      </Modal.Body>
      <Modal.Footer
        hidden={!(footerConfig.noOfBtns !== 0 && footerConfig.noOfBtns === 1)}
        className="justify-content-center pt-0"
      >
        <button
          onClick={onModalClose}
          className="admin-modal-btn text-capitalize px-3 py-1 rounded"
        >
          okay
        </button>
      </Modal.Footer>
      <Modal.Footer
        hidden={!(footerConfig.noOfBtns !== 0 && footerConfig.noOfBtns === 2)}
        className="justify-content-center pt-0"
      >
        <button
          onClick={onClickCancel}
          className="admin-modal-btn text-capitalize px-3 py-1 rounded"
        >
          {footerConfig.cancelBtnLabel}
        </button>
        <button
          onClick={handleProceed}
          className="admin-footer-proceed-btn text-capitalize px-3 py-1 rounded"
        >
          {footerConfig.proceedBtnLabel}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default forwardRef(CModal);
